import React from 'react';
import styles from './NoReferrerMessage.css';

const NoReferrerMessage = () => {
    return (
      <div className={styles.wrapper}>
        <p className={styles.paragraph}>
          <strong>For Advertisers: </strong> Traffic to this site is generated through Airfind&apos;s proprietary technology which allows us to place native ads with targeted keywords on multiple platforms, which then lead to our various sites where search ads are served.
        </p>
      </div>
    );
  };

export default NoReferrerMessage;